// src/app/services/organization.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment'; 
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})


export class OrganizationService {
  baseUrl = environment.baseUrl;

  private apiUrl = `${this.baseUrl}/client-admin/organization-list/`;

  constructor(private http: HttpClient) {}

  getOrganizations(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  activateSuperadmin(orgId: string): Observable<any> {
    const url = `${this.baseUrl}/client-admin/organization/${orgId}/activate/`;
    return this.http.post(url, {});
  }

   deleteOrganization(orgId: string): Observable<any> {
    const url = `${this.baseUrl}/client-admin/organization/${orgId}/`;
    return this.http.delete(url); 
  }
}
